module.exports = __webpack_public_path__ + "app/bento-components/blog-river/media/disabledIcon.svg";